import { memo } from 'react'
import { CopyPlus, Trash2, X } from 'lucide-react'
import { formatDuration, formatTime } from '../../lib/utils.js'
import { Button } from '../ui/button.js'
import type { GridSelection } from './useGridSelection.js'

interface GridSelectionBarProps {
  selection:      GridSelection
  onRebroadcast?: () => void
  onDelete?:      () => void
  busy?:          boolean
}

/**
 * Barre d'actions de la sélection multiple. Elle n'apparaît qu'à partir de deux
 * éléments : un clic simple sélectionne déjà, et faire surgir une barre à chaque
 * consultation d'un programme reviendrait à déplacer la grille sous le pointeur.
 */
export const GridSelectionBar = memo(function GridSelectionBar({
  selection,
  onRebroadcast,
  onDelete,
  busy = false,
}: GridSelectionBarProps) {
  const { count, span } = selection
  if (count < 2 || !span) return null

  return (
    <div className="agenda-selection-bar" role="region" aria-label="Sélection de la grille">
      <div className="agenda-selection-bar__summary">
        <strong>{count} éléments sélectionnés</strong>
        <span>
          {formatTime(span.start).slice(0, 5)} → {formatTime(span.end).slice(0, 5)}
          {' · '}
          {formatDuration(span.durationSec)}
        </span>
      </div>

      <div className="agenda-selection-bar__actions">
        {onRebroadcast && (
          <Button variant="default" size="sm" onClick={onRebroadcast} disabled={busy}>
            <CopyPlus data-icon="inline-start" aria-hidden="true" />
            Rediffuser…
          </Button>
        )}
        {onDelete && (
          <Button variant="outline" size="sm" onClick={onDelete} disabled={busy}>
            <Trash2 data-icon="inline-start" aria-hidden="true" />
            Supprimer
          </Button>
        )}
        <Button variant="ghost" size="sm" onClick={selection.clear} disabled={busy}>
          <X data-icon="inline-start" aria-hidden="true" />
          Désélectionner
        </Button>
      </div>
    </div>
  )
})

export default GridSelectionBar
